const createCommonActions = (reduceTimeoutCount) => {
  return [
    {
      action: "adjustTeamValue",
      value: 1,
      options: { currentEntity: true, item: "timeouts" },
    },
    reduceTimeoutCount
      ? {
          action: "adjustTeamValue",
          value: -1,
          options: { currentEntity: false, item: "timeouts" },
        }
      : {},
    {
      action: "sendEvent",
      value: "edit",
      type: "main",
    },
    {
      action: "nextState",
      value: null,
      type: "editState",
    },
  ];
};

export var ModifyTimeoutEntity = {
  name: "timeout-entity",
  component: "MainPanel",
  layout: "main-panel x-large align-center",
  mode: "visible",
  text: "timeout.type",
  showOn: [{ state: "editState", value: "timeout-entity", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "team-0-timeout-non-official",
      component: "TypeButton",
      layout: "match-button margin-top",
      mode: "visible",
      text: { team: "name" },
      showOn: [
        {
          state: "event.entityId",
          value: ["official"],
          operator: "not",
          event: "main",
        },
        {
          state: "entity.isOnEvent",
          value: 0,
          operator: "not",
          event: "main",
        },
      ],
      options: { team: 0 },
      actionGroups: [
        {
          actions: createCommonActions(true),
          conditions: [],
        },
      ],
    },
    {
      name: "team-0-timeout-official",
      component: "TypeButton",
      layout: "match-button margin-top",
      mode: "visible",
      text: { team: "name" },
      showOn: [
        {
          state: "event.entityId",
          value: "official",
          operator: "is",
          event: "main",
        },
        {
          state: "entity.isOnEvent",
          value: 0,
          operator: "not",
          event: "main",
        },
      ],
      options: { team: 0 },
      actionGroups: [
        {
          actions: createCommonActions(false),
          conditions: [],
        },
      ],
    },
    {
      name: "official-timeout",
      component: "TypeButton",
      layout: "match-button margin-top",
      mode: "visible",
      text: "official",
      showOn: [
        {
          state: "event.entityId",
          value: "official",
          operator: "not",
          event: "main",
        },
      ],
      actionGroups: [
        {
          actions: [
            {
              action: "adjustTeamValue",
              value: -1,
              options: { currentEntity: true, item: "timeouts" },
            },
            { action: "clearData", value: ["entityId"], type: "main" },
            {
              action: "sendEvent",
              value: "edit",
              type: "main",
            },
            {
              action: "nextState",
              value: null,
              type: "editState",
            },
          ],
          conditions: [],
        },
      ],
    },
    {
      name: "team-1-timeout-non-official",
      component: "TypeButton",
      layout: "match-button margin-top",
      mode: "visible",
      text: { team: "name" },
      showOn: [
        {
          state: "event.entityId",
          value: ["official"],
          operator: "not",
          event: "main",
        },
        {
          state: "entity.isOnEvent",
          value: 1,
          operator: "not",
          event: "main",
        },
      ],
      options: { team: 1 },
      actionGroups: [
        {
          actions: createCommonActions(true),
          conditions: [],
        },
      ],
    },
    {
      name: "team-1-timeout-official",
      component: "TypeButton",
      layout: "match-button margin-top",
      mode: "visible",
      text: { team: "name" },
      showOn: [
        {
          state: "event.entityId",
          value: "official",
          operator: "is",
          event: "main",
        },
        {
          state: "entity.isOnEvent",
          value: 1,
          operator: "not",
          event: "main",
        },
      ],
      options: { team: 1 },
      actionGroups: [
        {
          actions: createCommonActions(false),
          conditions: [],
        },
      ],
    },
  ],
};
